import request from '../../libs/request';

export default {
  home: (queryParams, siteId) => {
    return request(`api/v1/${siteId}/pagina/publications/desktop/home`).get({ queryParams });
  },

  product: (id, siteId) => {
    return request(`api/v1/${siteId}/pagina/publications/desktop/produto/${id}`).get();
  },

  category: (position, category, siteId) => {
    return request(`api/v1/${siteId}/pagina/publication/desktop/${position}/category/${category}`).get();
  },

  hotsite: (query, siteId) => {
    return request(`api/v1/${siteId}/pagina/publications/desktop/hotsite/${query}`).get();
  },
};
